import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { SpinnerService } from './core/spinner/spinner.service';
import { NewsletterModel } from './core/models/newsletter-model';
import { AppService } from './app.service';
import { ToastService } from './core/toast/toast.service';
import { LanguageService } from './core/language/language.service';

//Dodato zbog console errora
declare global {
    interface Navigator {
        msSaveBlob: (blob: any, defaultName?: string) => boolean
    }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
}) 


export class AppComponent implements OnInit {
    title = 'app';
    public isHovering: boolean;
    public newsletter: NewsletterModel;

    constructor(private _router: Router,
        private _spinnerService: SpinnerService,
        private _appService: AppService,
        private _toastService: ToastService,
        private _languageService: LanguageService) {
        this.isHovering = false;
        this.newsletter = new NewsletterModel();
    }

    ngOnInit() {
        this._router.events.subscribe(event => {
            if (event instanceof RouteConfigLoadStart) {
                this._spinnerService.showRouteLoader();
            }
            else if (event instanceof RouteConfigLoadEnd) {
                this._spinnerService.hideRouteLoader();
            }
        })
        this.initModel();
    
    }

    initModel() {
        if (this.newsletter == null)
            this.newsletter = new NewsletterModel();

        this.newsletter.id = 0;
        this.newsletter.email = "";
        this.newsletter.active = false;
        this.newsletter.dateCreated = null;
    }

    subscribeTo() {
        //if (this.newsletter.email != null && this.newsletter.email != "") {
            this._appService.subscribeToNewsletter(this.newsletter).subscribe(result => {
                this._toastService.activate(this._languageService.instant('uspjesna_prijava_na_newsletter'));
                this.newsletter.email = "";
            });
        //}
    }

    downloadUserManual() {
        var contentType = 'application/pdf';
        var success = false;
        let filename = "KORISNICKO_UPUTSTVO.pdf"

        this._appService.downloadUserManual().subscribe(res => {
                try {
                    var blob = new Blob([res], { type: contentType });
                    if (navigator.msSaveBlob)
                        navigator.msSaveBlob(blob, filename);
                    else {
                        var saveBlob = navigator.msSaveBlob;// || navigator.mozSaveBlob || navigator.saveBlob;
                        if (saveBlob === undefined) throw "Not supported";
                        saveBlob(blob, filename);
                    }
                    success = true;
                } catch (ex) {
                }

                if (!success) {
                    var urlCreator = window.URL //|| window.webkitURL || window.mozURL || window.msURL;
                    if (urlCreator) {
                        var link = document.createElement('a');
                        if ('download' in link) {
                            try {
                                // Prepare a blob URL                            
                                var blob = new Blob([res], { type: contentType });
                                var url = urlCreator.createObjectURL(blob);
                                link.setAttribute('href', url);

                                link.setAttribute("download", filename);

                                var event = document.createEvent('MouseEvents');
                                event.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 0, null);
                                link.dispatchEvent(event);
                                success = true;

                            } catch (ex) {
                            }
                        }

                        if (!success) {
                            try {
                                var blob = new Blob([res], { type: contentType });
                                var url = urlCreator.createObjectURL(blob);
                                //window.location = url;
                                window.open(url, "_blank");
                                success = true;
                            } catch (ex) {
                            }
                        }
                    }
                }
            }
        );
    }
    
}
